if (!customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends HTMLElement {
    constructor() {
      super();
      this.currentUnit = 'cm';
      this.guideType = this.dataset.sizeGuideType || 'all';

      const jsonScript = this.querySelector('script[type="application/json"]');
      this.allData = jsonScript ? JSON.parse(jsonScript.textContent) : {};

      this._boundKeydown = this._handleKeydown.bind(this);
      this._init();
    }

    _init() {
      this._bindOverlay();
      this._bindClose();
      this._bindToggle();
      this.renderTable();
    }

    _bindOverlay() {
      const overlay = this.querySelector('[data-sg-overlay]');
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }
    }

    _bindClose() {
      const closeBtn = this.querySelector('[data-sg-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }
    }

    _bindToggle() {
      this.querySelectorAll('[data-sg-unit]').forEach((btn) => {
        btn.addEventListener('click', () => this.switchUnit(btn.dataset.sgUnit));
      });
    }

    _handleKeydown(e) {
      if (e.key === 'Escape') this.close();
    }

    open() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        this._bindOverlay();
        this._bindClose();
      }

      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._boundKeydown);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.add('active');
        });
      });

      const closeBtn = this.querySelector('[data-sg-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.classList.remove('active');
      document.removeEventListener('keydown', this._boundKeydown);

      const inner = this.querySelector('.sg-drawer__inner');
      const onEnd = () => {
        document.body.style.overflow = '';
        inner.removeEventListener('transitionend', onEnd);
      };
      if (inner) {
        inner.addEventListener('transitionend', onEnd, { once: true });
      } else {
        document.body.style.overflow = '';
      }
    }

    switchUnit(unit) {
      this.currentUnit = unit;
      this.querySelectorAll('[data-sg-unit]').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.sgUnit === unit);
      });
      const toggle = this.querySelector('[data-sg-toggle]');
      if (toggle) toggle.dataset.activeUnit = unit;
      this.renderTable();
    }

    renderTable() {
      const container = this.querySelector('[data-sg-table]');
      const data = this.allData[this.guideType] || this.allData['all'];
      if (!data || !container) return;

      const columns = this.currentUnit === 'cm' ? data.columns_cm : data.columns_in;
      const rows = data.rows;
      const keys = this._getKeys(columns);

      let html = '<div class="sg-drawer__table-wrap"><table class="sg-drawer__table">';
      html += '<thead><tr>';
      columns.forEach((col) => { html += '<th>' + col + '</th>'; });
      html += '</tr></thead><tbody>';

      rows.forEach((row) => {
        html += '<tr>';
        keys.forEach((key) => { html += '<td>' + (row[key] || '') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table></div>';

      if (data.has_height && data.height_info) {
        html += '<div class="sg-drawer__height">';
        html += '<p class="sg-drawer__height-title">Body Height</p>';
        var labels = { petite: 'Petite', regular: 'Regular', tall: 'Tall' };
        Object.entries(data.height_info).forEach(([k, v]) => {
          html += '<div class="sg-drawer__height-row"><span class="sg-drawer__height-label">' + (labels[k] || k) + '</span><span class="sg-drawer__height-value">' + v + '</span></div>';
        });
        html += '</div>';
      }

      html += '<p class="sg-drawer__note">Please note that our guide is based on your body measurements, not the measurements of the products. Our Size Guide works as a guideline only, therefore fits and sizes may vary between products.</p>';

      container.innerHTML = html;
    }

    _getKeys(columns) {
      var unit = this.currentUnit;
      return columns.map((col) => {
        var l = col.toLowerCase();
        if (l === 'size') return 'size';
        if (l === 'uk') return 'uk';
        if (l === 'eu') return 'eu';
        if (l === 'us') return 'us';
        if (l === 'bust') return 'bust_' + unit;
        if (l === 'waist') return 'waist_' + unit;
        if (l === 'hips') return 'hips_' + unit;
        return l;
      });
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
